<template>
  <transition name="slide-fade">
    <v-container fluid>
      <v-layout wrap class="justify-end">
        <v-flex xs12>
          <h3 class="text-center">Drugs</h3>
        </v-flex>
        <v-flex xs12 sm6 md6>
          <form @submit.prevent="getData">
            <v-text-field label="Search" v-model="filterBy" prepend-inner-icon="search" clearable :loading="searching" :persistent-hint="search && search.length > 0" :hint="search && search.length ? `${meta.total} found!` : 'Type a name to search'" dense single-line>
              <template v-slot:append-outer>
                <v-btn x-small text outlined :loading="searching" v-show="filterBy && filterBy.length > 0" @click="getData" title="Search">Search</v-btn>
              </template>
            </v-text-field>
          </form>
        </v-flex>
      </v-layout>
      <portal to="links">
        <v-layout wrap justify-space-between v-show="drugs.data && drugs.data.length > 0">
          <v-btn small link :href="links.prev" @click.stop.prevent="goTo(links.prev, { search }, { preserveState: true })" :disabled="!links.prev" icon title="Previous page">
            <v-icon>mdi-chevron-double-left</v-icon>
          </v-btn>
          <v-btn small link :href="links.next" @click.stop.prevent="goTo(links.next, { search }, { preserveState: true })" :disabled="!links.next" icon title="Next page">
            <v-icon>mdi-chevron-double-right</v-icon>
          </v-btn>
        </v-layout>
      </portal>
      <v-card flat class="mt-1">
        <v-sheet>
          <portal-target name="links"></portal-target>
        </v-sheet>
        <v-card-text>
          <drugs-grid :drugs="drugs.data" :key="search + ' data'"></drugs-grid>
          <div v-if="!drugs.data || drugs.data.length === 0">
            <div v-if="search && search.length > 0">Nothing found matching <em>{{ search }}</em></div>
            <div v-else>Nothing found.</div>
          </div>
        </v-card-text>
        <v-sheet>
          <portal-target name="links"></portal-target>
        </v-sheet>
      </v-card>
    </v-container>
  </transition>
</template>

<script>
  import layout from '@/Layouts/Guest'
  const DrugsGrid =  async () => await import( /* webpackMode: 'lazy' */ /* webpackChunkName: "drugs" */ '@/Components/Drugs/gridIndex')

  export default {
    name: 'DrugsResourceIndex',
    layout,
    props: {
      drugs: Object,
      search: {
        type: String,
        default: '',
      },
    },
    components: {
      DrugsGrid,
    },
    metaInfo () {
      return {
        title: 'Drugs',
        titleTemplate: '%s | ' + this.$title,
      }
    },
    data () {
      return {
        filterBy: this.search,
        searching: false,
      }
    },
    methods: {
      getData () {
        this.$inertia.get('/resources/drugs', {
          search: this.filterBy
        },
        {
          preserveState: true,
          preserveScroll: true,
          onBefore: () => this.searching = true,
          onFinish: () => this.searching = false,
        })
      },
    },
    computed: {
      links () {
        return this.drugs.links
      },
      meta () {
        return this.drugs.meta
      }
    },
    watch: {
      'filterBy': _.debounce(function (value, old) {
        if (!value || value.length == 0) {
          let vm = this
          setTimeout(function () {
            vm.getData()
          }, 1000)
        }
      }, 3000)
    }
  }
</script>

<style>
   /**/
</style>
